import { IStaticPage } from "../Interfaces/IStaticPage";
import colors from "../Assets/Colors/Colors.json";


const StaticPage: React.FC<IStaticPage> = (props) => {
  const { pageHeader, coverImage, elements,elementIndex } = props;

  const fullScreen =()=>{
    const video = document.getElementById('video')
    if(video){
      video.requestFullscreen();
    }
  }


  return (
    <div style={styles.mainContainer}>
      <div
        style={{
          backgroundImage: coverImage && `url(${coverImage._url})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          height: "26vh",
          position: "relative",
        }}
      >
        <div style={styles.coverElements}>
          <div style={styles.title}>{elements[elementIndex].header}</div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "3rem",
          alignSelf:'center'
        }}
      >  
      {elements &&
      <>
          <div>
            <h5>{elements[elementIndex].subHeader}</h5>
            
          </div>
          <video 
              width="60%" 
              controls
              style={{
                alignSelf:'center',
                borderColor:colors.darkBlue,
                border:'0.2rem solid',
                marginBottom:'2rem'
              }}
              poster={elements[elementIndex].previewImage._url}
              id={'video'}
              onPlay={()=>fullScreen()}
          >
            <source src={elements[elementIndex].video._url} type="video/mp4"></source>
          </video>
      </>
     }
      </div>
    </div>
  );
};

const styles: any = {
  mainContainer: {
    // paddingTop: "3rem",
    alignItems: "center",
    flexDirection: "column",
    zIndex: "10",
  } as React.CSSProperties,
  cover: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    height: "20.5vh",
    position: "relative",
  } as React.CSSProperties,
  title: {
    color: colors.whiteSmoke,
    fontSize: "1.8rem",
    lineHeight: "3rem",
    letterSpacing: "0.05625rem",
    textShadow: `2px 2px ${colors.black}`,
    fontFamily: "FbReforma-Medium",
    marginTop:'2rem',
    maxWidth:'80%',
    textAlign:'center'
  } as React.CSSProperties,
  breadcrumb: {
    display: "flex",
    color: colors.black,
    fontSize: "1rem",
    letterSpacing: "0.05625rem",
    fontFamily: "FbReforma-Regular",
    cursor: "pointer",
    gap: ".5rem",
  } as React.CSSProperties,
  coverElements: {
    // position: "absolute",
    display: "flex",
    flexDirection: "column",
    right: "15%",
    top: "18%",
    gap: "1.5rem",
    alignItems: 'center'
  } as React.CSSProperties,
  content: {
    position: "relative",
    paddingTop: "5rem",
    right: "25%",
    width: "50%",
  } as React.CSSProperties,
  titlesAndDescriptionsItems: {
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
  } as React.CSSProperties,
  linkItems: {
    cursor: "pointer",
  } as React.CSSProperties,
};

export default StaticPage;
